import { FooterStyled } from "./Footer.styled";
import dividerline from "../../images/cashbach/divider-line.svg"
import insta from "../../images/cashbach/instagram-fill1.svg"
import facebook from "../../images/cashbach/facebook.svg"
import tiktok from "../../images/cashbach/tiktok.png"

import { checkIsMobile } from "../../Utills/Utill";
import { useHistory } from "react-router-dom";


const Footer = () => {
  const history = useHistory();
  return (
    <>
      <FooterStyled>
        <div className="footer-main-section">
          <div className="footer-top-section">
            <div className="termsandconditions">
              <div 
              onClick={() => history.push('/termsandconditions')}
              >
              Términos y Condiciones
              </div> 
              {!checkIsMobile() && <img src={dividerline} alt="UserIcon"/>}
              <div onClick={() => history.push('/privacypolicy')} className="privacypolicy">
              Política de Privacidad
              </div> 
              {!checkIsMobile() && <img src={dividerline} alt="UserIcon"/>}
              <div>
              Contáctanos
              </div>

            </div>
            <div className="social-media">
              <div>
              Síguenos en :
              </div>
              <div 
              onClick={() => window.location.href = "https://www.instagram.com/cashbackcolombia_?igsh=MWJsYmptNXNhemZ0cQ=="}
              >
                <img src={insta} alt="insta"/>
              </div>
              <div
              onClick={() => window.location.href = "https://www.facebook.com/Cashbackcol/"}
              >
                <img src={facebook} alt="facebook"/>
              </div>
              <div
              onClick={() => window.location.href = "https://www.tiktok.com/@cashbackcolombia?lang=es"}
              >
                <img src={tiktok} alt="tiktok"/>
              </div>
            </div>

          </div>
          <div className="footer-bottom-section">
            <div>
            Owned by Cash Back Colombia SAS a Colombian corporation.
            </div>
            </div>
        </div>
      </FooterStyled>
    </>
  );
};

export default Footer;
